function mergeId(i1, i2) {
  return [i1, i2].filter(item => !!item).join('-')
}

function mergeTolls(t1, t2) {
  return [t1, t2].reduce((total, num) => total + (num || 0), 0)
}

function mergeActions(s1, s2) {
  let showShapeLength = s1.showShape.length
  let list = [].concat(s1.actions)
  s2.actions.map(item => {
    list.push({ ...item, firstPoint: item.firstPoint + showShapeLength, lastPoint: item.lastPoint + showShapeLength })
  })
  return list
}

function mergeSections(s1, s2) {
  if (s1 && s2) {
    let _sections1 = s1.sections[0]
    let _sections2 = s2.sections[0]

    return {
      objectType: s1.objectType,
      sections: [
        {
          actions: mergeActions(_sections1, _sections2),
          id: mergeId(_sections1.id, _sections2.id),
          maneuver: [].concat(_sections1.maneuver, _sections2.maneuver),
          notices: [].concat(_sections1.notices, _sections2.notices),
          routeHandle: [_sections1.routeHandle, _sections2.routeHandle].join('|'),
          routeShape: [].concat(_sections1.routeShape, _sections2.routeShape),
          routeShape2: [].concat(_sections1.routeShape2, _sections2.routeShape2),
          showShape: [].concat(_sections1.showShape, _sections2.showShape),
          strategy: Object.assign({}, _sections1.strategy, _sections2.strategy),
          summary: {
            duration: _sections1.summary.duration + _sections2.summary.duration,
            length: _sections1.summary.length + _sections2.summary.length
          },
          tolls: [].concat(_sections1.tolls, _sections2.tolls),
          violation: [].concat(_sections1.violation, _sections2.violation)
        }
      ]
    }
  } else {
    return s1 || s2
  }




  
}

export function routeJsonformat(routeJson, waypoint) {
  let { waypointsAndShapes, concatenated_routes } = routeJson.routes
  let cr = concatenated_routes[0]
  let routeInfo = {
    ids: [],
    section_tolls: []
  }
  let list = []
  let wIndex = 0
  let wIndex2 = 0
  let sIndex = 0
  waypointsAndShapes.map(item => {
    if (item.objectType === 'waypoint') {
      let currentW = waypoint[wIndex]
      let stopType = currentW.stopType === 'Pick Up' ? 'Pick up' : currentW.stopType
      if (!currentW.hidden) {
        list.push({ ...item, 
          stopType: stopType, 
          index: wIndex2, 
          timeZone: currentW.timeZone,
          city: currentW.pointInfo.city,
          county: currentW.pointInfo.county,
          stateCode: currentW.pointInfo.stateCode,
          title: currentW.pointInfo.title
         })
        wIndex2++
      }
      wIndex++
    } else {
      let lastObj = list[list.length - 1]
      if (lastObj.objectType === 'routeSection') {
        list.splice(list.length - 1, 1, mergeSections(lastObj, item))
        routeInfo.section_tolls.splice(
          routeInfo.section_tolls.length - 1,
          1,
          mergeTolls(routeInfo.section_tolls[routeInfo.section_tolls.length - 1], cr.section_tolls[sIndex])
        )
        routeInfo.ids.splice(routeInfo.ids.length - 1, 1, mergeId(routeInfo.ids[routeInfo.ids.length - 1], cr.ids[sIndex]))
      } else {
        list.push(item)
        routeInfo.section_tolls.push(cr.section_tolls[sIndex])
        routeInfo.ids.push(cr.ids[sIndex])
      }
      sIndex++
    }
  })
  return {
    ...routeJson,
    routes: {
      concatenated_routes: [Object.assign({}, cr, routeInfo)],
      waypointsAndShapes: list
    }
  }
}

function getSections(routeJson) {
  let list = []
  routeJson.routes.waypointsAndShapes.forEach(ele => {
    if (ele.objectType === 'routeSection') {
      list.push(Object.assign({}, ele.sections[0]))
    }
  })
  return Object.freeze(list)
}

export function getLegAndShare(routeJson, waypoint) {
  let _routeJson = routeJsonformat(routeJson, waypoint)
  let sections = getSections(_routeJson)
  return {
    leg: sections.map(s => {
      return {maneuver : s.routeShape.map(x => {
          return {position: { latitude: x[0], longitude: x[1] }}
        })}
    }),
    routeShape2: sections.map(s => s.routeShape2),
  }
}